import { useState, useEffect } from "react";
import { puedeCrear } from "../auth/permisos";
import DateInput from "../../shared/components/DateInput";

import { avisarError } from "../../shared/errores";
import { directorioMiembros, eliminar as eliminarFila, guardar as guardarFila, listar, unir } from "../../services/datos";
import { avisar, confirmar } from "../../shared/avisos";
import Selector from "../../shared/components/Selector";
import Esqueleto from "../../shared/components/Esqueleto";

const camposIniciales = {
  nombres: "",
  apellidos: "",
  fecha_visita: "",
  direccion: "",
  telefono: "",
  servicio_id: "",
  invitado_por_id: "",
  convertido_miembro_id: "",
  notas: ""
};

function FormularioVisita({ inicial, servicios, miembros, onGuardar, onCancelar }) {
  const [form, setForm] = useState(inicial ? {
    ...inicial,
    servicio_id: inicial.servicio_id ? String(inicial.servicio_id) : "",
    invitado_por_id: inicial.invitado_por_id ? String(inicial.invitado_por_id) : "",
    convertido_miembro_id: inicial.convertido_miembro_id ? String(inicial.convertido_miembro_id) : ""
  } : camposIniciales);
  const input = "campo";
  const label = "etiqueta";

  useEffect(() => {
    if (inicial) {
      setForm({
        ...inicial,
        servicio_id: inicial.servicio_id ? String(inicial.servicio_id) : "",
        invitado_por_id: inicial.invitado_por_id ? String(inicial.invitado_por_id) : "",
        convertido_miembro_id: inicial.convertido_miembro_id ? String(inicial.convertido_miembro_id) : ""
      });
    } else {
      setForm(camposIniciales);
    }
  }, [inicial]);

  const handleSubmit = () => {
    if (!form.nombres || !form.apellidos || !form.fecha_visita || !form.direccion) {
      avisar("Nombres, fecha y dirección son obligatorios");
      return;
    }
    onGuardar(form);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black/80 p-4 backdrop-blur-sm ventana-fondo">
      <div className="w-full max-w-2xl max-h-[90vh] overflow-y-auto rounded-2xl border border-white/10 bg-zinc-950 p-6 sm:p-8 ventana-panel">
        <h3 className="titulo-ventana mb-5">{inicial ? "Editar Visita" : "Registrar Visita"}</h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className={label}>Nombres *</label>
            <input
              className={input}
              value={form.nombres}
              onChange={(e) => setForm({ ...form, nombres: e.target.value })}
              placeholder="Nombres del visitante"
            />
          </div>
          <div>
            <label className={label}>Apellidos *</label>
            <input
              className={input}
              value={form.apellidos}
              onChange={(e) => setForm({ ...form, apellidos: e.target.value })}
              placeholder="Apellidos del visitante"
            />
          </div>
          <DateInput
            label="Fecha de visita *"
            className={input}
            value={form.fecha_visita}
            onChange={(e) => setForm({ ...form, fecha_visita: e.target.value })}
          />
          <div>
            <label className={label}>Teléfono</label>
            <input
              className={input}
              value={form.telefono}
              onChange={(e) => setForm({ ...form, telefono: e.target.value })}
              placeholder="Teléfono"
            />
          </div>
          <div>
            <label className={label}>Dirección *</label>
            <input
              className={input}
              value={form.direccion}
              onChange={(e) => setForm({ ...form, direccion: e.target.value })}
              placeholder="Dirección del visitante"
            />
          </div>
          <div>
            <label className={label}>Servicio</label>
            <Selector
              className={input}
              value={form.servicio_id}
              onChange={(e) => setForm({ ...form, servicio_id: e.target.value })}
            >
              <option value="">Seleccionar servicio</option>
              {servicios.map((s) => (
                <option key={s.id} value={s.id}>{s.titulo || s.fecha}</option>
              ))}
            </Selector>
          </div>
          <div>
            <label className={label}>Invitado por</label>
            <Selector
              className={input}
              value={form.invitado_por_id}
              onChange={(e) => setForm({ ...form, invitado_por_id: e.target.value })}
            >
              <option value="">Seleccionar miembro</option>
              {miembros.map((m) => (
                <option key={m.id} value={m.id}>{m.nombres} {m.apellidos}</option>
              ))}
            </Selector>
          </div>
          <div className="md:col-span-2">
            <label className={label}>Notas</label>
            <textarea
              className={input}
              rows={4}
              value={form.notas}
              onChange={(e) => setForm({ ...form, notas: e.target.value })}
              placeholder="Notas adicionales"
            />
          </div>
        </div>

        <div className="flex gap-3 mt-6">
          <button onClick={handleSubmit} className="flex-1 btn-primario">Guardar visita</button>
          <button onClick={onCancelar} className="flex-1 btn-fantasma">Cancelar</button>
        </div>
      </div>
    </div>
  );
}

function VisitasNuevas({ usuario }) {
  const [visitas, setVisitas] = useState([]);
  const [servicios, setServicios] = useState([]);
  const [miembros, setMiembros] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [buscar, setBuscar] = useState("");
  const [mostrarForm, setMostrarForm] = useState(false);
  const [visitaEditar, setVisitaEditar] = useState(null);

  const cargar = () => {
    setCargando(true);
    Promise.all([
      listar("visitas_nuevas", { orden: "fecha_visita", descendente: true }),
      listar("servicios", { select: "id, fecha, hora, titulo, tipos_servicio(nombre)", orden: "fecha", descendente: true }),
      directorioMiembros(),
    ])
      .then(([visitasData, serviciosData, miembrosData]) => {
        setVisitas(unir(unir(visitasData, "servicio_id", serviciosData, "servicios"), "invitado_por_id", miembrosData, "miembros"));
        setServicios(serviciosData);
        setMiembros(miembrosData);
        setCargando(false);
      })
      .catch((e) => { setCargando(false); avisarError(e); });
  };

  useEffect(() => { cargar(); }, []);

  const guardar = (form) => {
    guardarFila("visitas_nuevas", visitaEditar?.id, form)
      .then(() => {
        setMostrarForm(false);
        setVisitaEditar(null);
        cargar();
      })
      .catch((e) => avisar(e.message, "error"));
  };

  const eliminar = async (id) => {
    if (!(await confirmar("¿Eliminar esta visita nueva?", { aceptar: "Eliminar" }))) return;
    eliminarFila("visitas_nuevas", id).then(() => cargar()).catch((e) => avisar(e.message, "error"));
  };

  const visitasFiltradas = visitas.filter((v) =>
    `${v.nombres} ${v.apellidos} ${v.direccion}`.toLowerCase().includes(buscar.toLowerCase())
  );

  return (
    <div className="p-6">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between mb-6">
        <div>
          <h2 className="titulo-pagina">Visitas Nuevas</h2>
          <p className="text-gray-400 text-sm mt-1">Seguimiento de visitas recientes</p>
        </div>
        {puedeCrear(usuario) ? (
          <button onClick={() => { setVisitaEditar(null); setMostrarForm(true); }} className="btn-primario">Registrar visita</button>
        ) : (
          <span className="text-sm text-gray-400">Solo pastor o administrador puede crear</span>
        )}
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-[280px_minmax(0,1fr)] gap-6 mb-6">
        <div className="panel p-4">
          <p className="text-gray-400 text-sm">Visitas registradas</p>
          <p className="text-white font-black text-4xl mt-2">{visitas.length}</p>
          <input
            value={buscar}
            onChange={(e) => setBuscar(e.target.value)}
            placeholder="Buscar visitante..."
            className="mt-4 campo"
          />
        </div>

        <div className="panel p-4 max-h-[72vh] overflow-y-auto">
          {cargando ? (
            <Esqueleto texto="Cargando visitas…" />
          ) : visitasFiltradas.length === 0 ? (
            <p className="text-gray-400">No se encontraron visitas.</p>
          ) : (
            <div className="space-y-3">
              {visitasFiltradas.map((v) => (
                <div key={v.id} className="rounded-2xl border border-gray-700 p-4 bg-oscuro">
                  <div className="flex items-start justify-between gap-4">
                    <div>
                      <p className="text-white text-lg font-semibold">{v.nombres} {v.apellidos}</p>
                      <p className="text-gray-400 text-sm">{v.fecha_visita} · {v.direccion}</p>
                      {v.servicios && <p className="text-gray-500 text-xs mt-1">Servicio: {v.servicios.titulo || v.servicios.fecha}</p>}
                    </div>
                    <button onClick={() => eliminar(v.id)} className="btn-peligro btn-sm">Eliminar</button>
                  </div>
                  {v.notas && <p className="text-gray-500 text-sm mt-3">{v.notas}</p>}
                  <button
                    onClick={() => { setVisitaEditar(v); setMostrarForm(true); }}
                    className="mt-4 btn-fantasma btn-sm"
                  >
                    Editar
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {mostrarForm && (
        <FormularioVisita
          inicial={visitaEditar}
          servicios={servicios}
          miembros={miembros}
          onGuardar={guardar}
          onCancelar={() => { setMostrarForm(false); setVisitaEditar(null); }}
        />
      )}
    </div>
  );
}

export default VisitasNuevas;
